module.exports = __webpack_public_path__ + "img/cards.c090d21a.png";